import { useTranslation } from "react-i18next";

export default function Materialen() {
  const { t } = useTranslation("schuifpui-reparatie");
  const rows = t("materialen.rows", { returnObjects: true }) as Array<{
    title: string;
    desc: string;
  }>;

  const images = [
    "/img/54-aluminium-sliding-patio-door.jpg",
    "/img/75-white-pvc-plastic-sliding.jpg",
    "/img/71-traditional-wooden-sliding-patio.jpg",
  ];

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("materialen.h2")}
        </h2>

        <div className="flex flex-col gap-12 md:gap-16">
          {rows.map((row, i) => (
            <div
              key={i}
              className={`flex flex-col ${i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"} items-stretch gap-6 md:gap-10`}
            >
              <div className="flex-1 relative min-h-[260px] md:min-h-0 rounded-xl overflow-hidden">
                <img
                  src={images[i]}
                  alt={`${row.title} schuifpui reparatie detail in Eindhoven`}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 flex flex-col justify-center">
                <h3 className="font-geist font-bold text-xl md:text-2xl text-brand-text mb-3 md:mb-4">
                  {row.title}
                </h3>
                <p className="font-geist text-sm md:text-base text-brand-text/70 leading-relaxed">
                  {row.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}